<template>
    <section class="city-map-legend__block">
        <div class="city-map-legend__subtitle" v-html="city"></div>
    </section>
</template>
<script>
    import HtmlTemplateModule from "../store-mixin";

    export default {
        name: 'HtmlTemplateTitle',
        mixins: [HtmlTemplateModule()],
    }
</script>

<style scoped lang="scss">
    .city-map-legend {


        &__block {
            background-color: #FFFFFF;

            text-align: center;
            padding: 15px 0;
            padding-top: 0;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            /*position: relative;*/
            z-index: 999;
            /*box-shadow: 0 -2px 6px 0px #DDDDDD;*/
            ::v-deep .emoji {
                height: 40px !important;
                width: 40px !important;
                vertical-align: middle !important;
            }
        }

        &__title {
            color: #292929;
            text-transform: uppercase;
            font-weight: bold;
            font-family: Bodoni-72;

            &.vertical {
                font-size: 32px;
            }

            &.horizontal {
                font-size: 26px;
            }


            &--img {
                height: 40px;
                width: 40px;
                vertical-align: middle !important;
            }
        }

        &__subtitle {
            font-family: Quicksand Book;
            font-size: 20px;
            color: #292929;

            .city-name {
                text-transform: uppercase;
            }
        }

        &__separator {
            position: relative;
            padding: 20px 0;


            .coords-label{
                position: relative;
                display: inline-block;
                .coords-text{
                    font-size: 30px;
                    display: inline-block;
                    z-index: 1;
                    background: white;
                    padding: 5px 30px;
                }
                .coords-line{
                    content: ' ';
                    display: block;
                    border-top: 3px solid #292929;
                    width: 120%;
                    left: -10%;
                    position: absolute;
                    top: calc(50% - 2px);
                    z-index: -1;
                }
            }
        }
    }

</style>

